import React from 'react';

function TeamSwitchModal({ isVisible, pendingTeam, onConfirm, onCancel }) {
  if (!isVisible || !pendingTeam) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>⚠️ Switch Team?</h3>
        <p>
          Switching to <strong>{pendingTeam.name}</strong> will reset your
          graphic to default settings (Game Preview + Classic design).
        </p>
        <p>
          <strong>All current data will be lost.</strong> Continue?
        </p>
        <div className="modal-actions">
          <button className="btn btn-primary" onClick={onCancel}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={onConfirm}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

export default TeamSwitchModal;
